export enum AmPmEnum {
    AM = 'AM',
    PM = 'PM',
}
